var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Rule',{attrs:{"ruleContent":_vm.ruleContent}})
}
var staticRenderFns = []

export { render, staticRenderFns }